export class ResetPassword {
    Email:string;
    Phone:string;
    ResetPasswordId?:number;
    EmailOtp?:number;
}
